export default __webpack_public_path__ + "static/logo-stencil_thee-infinite-25d6e46197f9e0f7697a8c843840f14f.png";